import { useEffect, useState } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { Box, Grid, media, xcss } from '@atlaskit/primitives';
import { TwcBackground } from '@atlassian/product-wireframes';

import { useSearchParameters } from '@/components/signup/hooks/use-search-parameters.tsx';
import { Modal } from '@/components/signup/layouts/modal';

import LeftHandSideV2 from './left-hand-side-V2';
import RightHandSideV2 from './right-hand-side-V2';
import { getTeamTypeWithFlow } from './utils';

const WorkOnFirstView = () => {
	const { teamType } = useSearchParameters();
	const teamTypeValue = getTeamTypeWithFlow(teamType);
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [selectedOption, setSelectedOption] = useState<string | null>(null);

	useEffect(() => {
		createAnalyticsEvent({
			action: 'viewed',
			eventType: 'screen',
			name: 'workOnFirstScreen',
			attributes: {
				teamType: teamTypeValue,
			},
		}).fire();
	}, []);

	return (
		<TwcBackground>
			<Modal size="lg" showBrandFooter={false} showProductLogoOnLargeScreens={true}>
				<Box xcss={responsiveWrapper}>
					<Grid gap="space.0" xcss={responsiveGridStyles}>
						<LeftHandSideV2 selectedOption={selectedOption} onSelectOption={setSelectedOption} />
						<Box xcss={rightHandSideWrapper}>
							<RightHandSideV2 contentType={selectedOption} />
						</Box>
					</Grid>
				</Box>
			</Modal>
		</TwcBackground>
	);
};

const responsiveGridStyles = xcss({
	width: '100%',
	height: '100%',
	gridTemplateColumns: '100%',
	[media.above.md]: {
		gridTemplateColumns: '50% 50%',
	},
});

const rightHandSideWrapper = xcss({
	display: 'none',
	[media.above.md]: {
		display: 'block',
	},
});

const responsiveWrapper = xcss({
	width: '100%',
	maxWidth: '1140px',
	height: 'auto',
	overflow: 'hidden',
	[media.above.md]: {
		height: '640px',
	},
});

export default WorkOnFirstView;
